import { Stack, Typography } from "@mui/material";
import { QRCode } from "Components/Shared/QRCode";
import { Resources, useResource } from "Translations/Resources";

const RESOURCES = Resources.Components.Affiliate;

type Props = {
  affiliateCode: string;
};

export const QRInvitation = ({ affiliateCode }: Props) => {
  const { t } = useResource();

  return (
    <Stack>
      <Typography
        variant="h6"
        fontWeight={500}
        fontSize={18}
        textAlign="center"
      >
        {t(RESOURCES.AffiliateLinkWithActions.QrInstructions)}
      </Typography>
      <QRCode
        content={affiliateCode}
        downloadFileName={t(RESOURCES.AffiliateLinkWithActions.QrCodeFileName)}
      />
    </Stack>
  );
};
